import {
  CancelMultiNarrative,
  CancelMultiNarrativeAction,
  CancelMultiNarrativeSuccess,
  CancelMultiNarrativeSuccessAction,
  ForceUnlockMultiNarrative,
  ForceUnlockMultiNarrativeAction,
  LockMultiNarrative,
  LockMultiNarrativeAction,
  LockMultiNarrativeSuccess,
  LockMultiNarrativeSuccessAction,
  ReceiveExtraNarrativeResponse,
  ReceiveExtraNarrativeResponseAction,
  ReceiveMultiNarrativeResponse,
  ReceiveMultiNarrativeResponseAction,
  ReceiveMultiNarrativeSingleResponse,
  ReceiveMultiNarrativeSingleResponseAction,
  ReceiveNarrativeResponseAction,
  ResetMultiNarrative,
  ResetMultiNarrativeAction,
  RestoreVersionMultiNarrative,
  RestoreVersionMultiNarrativeAction,
  RestoreVersionMultiNarrativeSuccess,
  RestoreVersionMultiNarrativeSuccessAction,
  SaveMultiNarrative,
  SaveMultiNarrativeAction,
  SaveMultiNarrativeFailedAction,
  SaveMultiNarrativeSuccess,
  SaveMultiNarrativeSuccessAction,
  SetExtraNarrativeVal,
  SetExtraNarrativeValAction,
  SetNarrativeVal,
  SetNarrativeValAction,
} from '../types';

export const MULTI_NARRATIVE_CANCEL = 'MULTI_NARRATIVE_CANCEL';
export const MULTI_NARRATIVE_FORCE_UNLOCK = 'MULTI_NARRATIVE_FORCE_UNLOCK';
export const MULTI_NARRATIVE_LOCK = 'MULTI_NARRATIVE_LOCK';
export const MULTI_NARRATIVE_UPDATE = 'MULTI_NARRATIVE_UPDATE';
export const MULTI_NARRATIVE_VERSION_RESTORE =
  'MULTI_NARRATIVE_VERSION_RESTORE';
export const RESTORE_VERSION_MULTINARRATIVE_ACTION =
  'RESTORE_VERSION_MULTINARRATIVE_ACTION';
export const SAVE_MULTINARRATIVE_ACTION = 'SAVE_MULTINARRATIVE_ACTION';
export const CANCEL_MULTINARRATIVE_ACTION = 'CANCEL_MULTINARRATIVE_ACTION';
export const FORCE_UNLOCK_MULTINARRATIVE_ACTION =
  'FORCE_UNLOCK_MULTINARRATIVE_ACTION';
export const LOCK_MULTINARRATIVE_ACTION = 'LOCK_MULTINARRATIVE_ACTION';
export const LOCK_MULTINARRATIVE_ACTION_SUCCESS =
  'LOCK_MULTINARRATIVE_ACTION_SUCCESS';
export const RESET_MULTINARRATIVE_ACTION = 'RESET_MULTINARRATIVE_ACTION';
export const CANCEL_MULTINARRATIVE_ACTION_SUCCESS =
  'CANCEL_MULTINARRATIVE_ACTION_SUCCESS';
export const SAVE_MULTINARRATIVE_ACTION_SUCCESS =
  'SAVE_MULTINARRATIVE_ACTION_SUCCESS';
export const SAVE_MULTINARRATIVE_ACTION_FAILED =
  'SAVE_MULTINARRATIVE_ACTION_FAILED';
export const SET_EXTRA_NARRATIVE_ACTION = 'SET_EXTRA_NARRATIVE_ACTION';
export const RESTORE_VERSION_MULTINARRATIVE_ACTION_SUCCESS =
  'RESTORE_VERSION_MULTINARRATIVE_ACTION_SUCCESS';
export const SET_NARRATIVE_ACTION = 'SET_NARRATIVE_ACTION';
export const RECEIVE_MULTI_NARRATIVE_FROM_API =
  'RECEIVE_MULTI_NARRATIVE_FROM_API';
export const RECEIVE_EXTRA_NARRATIVE_FROM_API =
  'RECEIVE_EXTRA_NARRATIVE_FROM_API';
export const RECEIVE_NARRATIVE_FROM_API = 'RECEIVE_NARRATIVE_FROM_API';
export const RECEIVE_MULTI_NARRATIVE_SINGLE_FROM_API =
  'RECEIVE_MULTI_NARRATIVE_SINGLE_FROM_API';

export const cancelMultiNarrative = (
  params: CancelMultiNarrative,
): CancelMultiNarrativeAction => {
  return {
    type: CANCEL_MULTINARRATIVE_ACTION,
    narrativeId: params.narrativeId,
    reportId: params.reportId,
  };
};

export const forceUnlockMultiNarrative = (
  params: ForceUnlockMultiNarrative,
): ForceUnlockMultiNarrativeAction => {
  return {
    type: FORCE_UNLOCK_MULTINARRATIVE_ACTION,
    narrativeId: params.narrativeId,
    reportId: params.reportId,
  };
};

export const lockMultiNarrative = (
  params: LockMultiNarrative,
): LockMultiNarrativeAction => {
  return {
    type: LOCK_MULTINARRATIVE_ACTION,
    narrativeId: params.narrativeId,
    reportId: params.reportId,
  };
};

export const lockMultiNarrativeSuccess = (
  params: LockMultiNarrativeSuccess,
): LockMultiNarrativeSuccessAction => {
  return {
    type: LOCK_MULTINARRATIVE_ACTION_SUCCESS,
    narrativeId: params.narrativeId,
    editor: params.editor,
    content: params.content,
  };
};

export const restoreVersionMultiNarrative = (
  params: RestoreVersionMultiNarrative,
): RestoreVersionMultiNarrativeAction => {
  return {
    type: RESTORE_VERSION_MULTINARRATIVE_ACTION,
    narrativeVersionId: params.narrativeVersionId,
    content: params.content,
    narrativeId: params.narrativeId,
  };
};

export const resetMultiNarrative = (
  params: ResetMultiNarrative,
): ResetMultiNarrativeAction => {
  return {
    type: RESET_MULTINARRATIVE_ACTION,
    narrativeId: params.narrativeId,
  };
};

export const cancelMultiNarrativeSuccess = (
  params: CancelMultiNarrativeSuccess,
): CancelMultiNarrativeSuccessAction => {
  return {
    type: CANCEL_MULTINARRATIVE_ACTION_SUCCESS,
    value: params.value,
  };
};

export const saveMultiNarrative = (
  params: SaveMultiNarrative,
): SaveMultiNarrativeAction => {
  return {
    type: SAVE_MULTINARRATIVE_ACTION,
    narrativeId: params.narrativeId,
    content: params.content,
    wordCount: params.wordCount,
    autoSave: params.autoSave,
    reportId: params?.reportId,
  };
};

export const saveMultiNarrativeSuccess = (
  params: SaveMultiNarrativeSuccess,
): SaveMultiNarrativeSuccessAction => {
  return {
    type: SAVE_MULTINARRATIVE_ACTION_SUCCESS,
    value: params.value,
    autosave: params.autosave,
  };
};

export const saveMultiNarrativeFailed = (): SaveMultiNarrativeFailedAction => {
  return {
    type: SAVE_MULTINARRATIVE_ACTION_FAILED,
  };
};

export const setExtraNarrativeVal = (
  params: SetExtraNarrativeVal,
): SetExtraNarrativeValAction => {
  return {
    type: SET_EXTRA_NARRATIVE_ACTION,
    value: params.val,
    id: params.id,
  };
};

export const restoreVersionMultiNarrativeSuccess = (
  params: RestoreVersionMultiNarrativeSuccess,
): RestoreVersionMultiNarrativeSuccessAction => {
  return {
    type: RESTORE_VERSION_MULTINARRATIVE_ACTION_SUCCESS,
    content: params.content,
    narrativeId: params.narrativeId,
  };
};

export const setNarrativeVal = (
  params: SetNarrativeVal,
): SetNarrativeValAction => {
  return {
    type: SET_NARRATIVE_ACTION,
    value: params.val,
  };
};

export const receiveMultiNarrativeResponse = (
  payload: ReceiveMultiNarrativeResponse,
): ReceiveMultiNarrativeResponseAction => {
  return {
    type: RECEIVE_MULTI_NARRATIVE_FROM_API,
    payload,
  };
};

export const receiveExtraNarrativeResponse = (
  payload: ReceiveExtraNarrativeResponse,
): ReceiveExtraNarrativeResponseAction => {
  return {
    type: RECEIVE_EXTRA_NARRATIVE_FROM_API,
    payload,
  };
};

export const receiveNarrativeResponse = (
  payload: string,
): ReceiveNarrativeResponseAction => {
  return {
    type: RECEIVE_NARRATIVE_FROM_API,
    payload,
  };
};

export const receiveMultiNarrativeSingleResponse = (
  payload: ReceiveMultiNarrativeSingleResponse,
): ReceiveMultiNarrativeSingleResponseAction => {
  return {
    type: RECEIVE_MULTI_NARRATIVE_SINGLE_FROM_API,
    payload,
  };
};
